// Box-editable text of the payroll email sent to coaches.
//
// Only two parts are editable — an opening paragraph (under the fixed greeting)
// and a signature (at the bottom). Everything the coach needs to ACT on — the
// totals, withholding, attachments note, approve button and deadline notice —
// is a locked core the box can't remove, so no template can ever produce an
// email without the approval link or the amount.
//
// Both texts may carry {variables} from the allowlist below. The same renderer
// runs server-side (the real send) and in the settings drawer (live preview).
export const COACH_EMAIL_TEXT_MAX = 1000;
/** The allowlisted variables, in the order the drawer shows them. */
export const COACH_EMAIL_VARIABLES = [
    { key: 'שם_המאמן', label: 'שם פרטי של איש הצוות' },
    { key: 'שם_מלא', label: 'שם מלא של איש הצוות' },
    { key: 'חודש', label: 'חודש הדוח' },
    { key: 'שם_העסק', label: 'שם העסק' },
    { key: 'שם_הסניף', label: 'שם יחידת הרווח וההפסד (אם יש)' },
];
/** What the opening paragraph says when the box hasn't written its own — the
 *  exact sentence the email carried before this was editable. */
export const DEFAULT_COACH_EMAIL_INTRO = 'מצורף הדוח שלך לחודש {חודש}.';
const KNOWN = new Set(COACH_EMAIL_VARIABLES.map((v) => v.key));
const TOKEN = /\{([^{}\s]+)\}/g;
/** Tokens in `text` that aren't allowlisted (e.g. a typo like {שם_מאמן}).
 *  Rejected on save — a typo would otherwise reach every coach verbatim. */
export function unknownCoachEmailVariables(text) {
    if (!text)
        return [];
    const out = new Set();
    for (const m of text.matchAll(TOKEN))
        if (!KNOWN.has(m[1]))
            out.add(m[1]);
    return [...out];
}
/** Fill the allowlisted variables. Unknown tokens are left as-is (save-time
 *  validation keeps them out; this just never guesses). */
export function renderCoachEmailText(text, values) {
    return text.replace(TOKEN, (whole, key) => KNOWN.has(key) ? (values[key] ?? '') : whole);
}
/** The intro the email will actually use: the box's own, or the default. */
export function effectiveCoachEmailIntro(intro) {
    return intro?.trim() ? intro.trim() : DEFAULT_COACH_EMAIL_INTRO;
}
//# sourceMappingURL=coach-email.js.map